var map = {
	"./404.svg": "sEM+",
	"./accounting.svg": "s64A",
	"./accountingTitle.svg": "G0eS",
	"./arrow-thin-down.svg": "Behp",
	"./arrow-thin-left.svg": "IOtJ",
	"./arrow-thin-right.svg": "eHir",
	"./arrow-thin-up.svg": "etJ3",
	"./black-nozzle.svg": "HUwC",
	"./blue-bank.svg": "mqrr",
	"./blue-checklist.svg": "gTnS",
	"./blue-factory.svg": "q802",
	"./blue-nozzle.svg": "ZEzV",
	"./blue-product.svg": "vpAW",
	"./blue-tablet.svg": "wOE4",
	"./blue-warranty.svg": "z/r8",
	"./bug.svg": "SVqS",
	"./building-columns-solid.svg": "WQcC",
	"./building-solid.svg": "D4pQ",
	"./business.svg": "Br7G",
	"./businessTitle.svg": "WlE0",
	"./car-side-solid.svg": "skH0",
	"./car-solid.svg": "0Agb",
	"./card-outline.svg": "x5ri",
	"./chart.svg": "RjYk",
	"./check-circleless-white.svg": "R7sp",
	"./check-circleless.svg": "YNNV",
	"./check.svg": "7ZS0",
	"./circle-info-solid.svg": "CYKC",
	"./circle.svg": "5gjf",
	"./city-solid.svg": "Kq3o",
	"./clipboard.svg": "KO/S",
	"./community.svg": "eMQv",
	"./communityTitle.svg": "KyAH",
	"./component.svg": "s2cW",
	"./daftar-koperasi-highlight.svg": "8aCN",
	"./daftar-pemilikan-tunggal-highlight.svg": "WD4A",
	"./daftar-syarikat-highlight.svg": "PKK5",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./e-hailing.svg": "hc2a",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./extended-bot-icon.svg": "UkTh",
	"./extended-khas-icon.svg": "0XeN",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./guide.svg": "z74U",
	"./house-solid.svg": "5Y3o",
	"./icon.svg": "vUvT",
	"./icon1benefits.svg": "ESbE",
	"./icon2benefits.svg": "4qco",
	"./icon3benefits.svg": "ZJku",
	"./icons1pflp.svg": "qhUv",
	"./icons2pflp.svg": "sUNU",
	"./icons3pflp.svg": "lStF",
	"./icons4pflp.svg": "0FQd",
	"./icons5pflp.svg": "fiAb",
	"./icons6pflp.svg": "4D1+",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./list-ul-solid.svg": "eRx1",
	"./list.svg": "vuHp",
	"./lock-solid.svg": "dFTN",
	"./lock.svg": "FnAU",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./moon.svg": "Ux9W",
	"./nested.svg": "798r",
	"./nozzle.svg": "BiIJ",
	"./oil-well-solid.svg": "3lG7",
	"./ow_clock1.svg": "276O",
	"./ow_clock2.svg": "wIuY",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./person-solid.svg": "mPgA",
	"./phone-solid.svg": "uWxH",
	"./pink-malaysia.svg": "PugX",
	"./posit1ve-l.svg": "H7pL",
	"./posit1ve-s.svg": "cCg9",
	"./qq.svg": "R2jY",
	"./red-ehailing.svg": "IrLc",
	"./repeat_solid.svg": "m6cO",
	"./shoppingCard.svg": "dNDk",
	"./star-outline.svg": "m/hQ",
	"./star.svg": "60zo",
	"./sun.svg": "ZJ0R",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./taskmaster.svg": "V6pt",
	"./taskmasterTitle.svg": "euTW",
	"./theme.svg": "hdtf",
	"./tree.svg": "3eCm",
	"./user-plus-solid.svg": "r8wk",
	"./user-tie-solid.svg": "mwRq",
	"./user.svg": "VdD3",
	"./volume2.svg": "WRFd",
	"./volumeX.svg": "af3k",
	"./wechat.svg": "pYJ+",
	"./x.svg": "abAw",
	"./yellow-checklist.svg": "ZuRN",
	"./yellow-nozzle.svg": "HUJZ",
	"./yellow-product.svg": "IJmp",
	"./yellow-tablet.svg": "fBB9",
	"./yellow-warranty.svg": "eDah",
	"./yellowred-checklist.svg": "Hk8F",
	"./yellowred-product.svg": "R5JX",
	"./yellowred-tablet.svg": "LsGf",
	"./yellowred-warranty.svg": "mme2",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 175